<template>
  <NuxtChild :product="product" />
</template>

<script>
export default {
  name: 'ProductPageMain',
  async asyncData ({ app, params, redirect }) {
    const product = await app.$api.default.getProduct(params.productId).catch(() => { return null })
    if (product && product.offerProduct && product.offerProduct.link) {
      const productName = product.offerProduct.link
      if (params.productName !== productName || Number(params.productId) !== product.offerProduct.id) {
        return redirect(301, app.localePath({ name: 'product', params: { productName, productId: product.offerProduct.id } }))
      }
    }
    return { product }
  },
  head () {
    return {
      title: this.$t('fields.product')
    }
  }
}
</script>
